export default __webpack_public_path__ + "static/thumbnail-60a26b0f4d53852383144dce4456d593.png";